import { temperatureList, temperatureTypesList } from './order.temperature.config';
import {
  statusActivityConfig,
  actionConfig,
  carrierNextStepConfig,
  adminNextStepConfig,
  orderFieldsConfig,
  podStatusConfig,
} from './order.status.config';
import { timeConfig } from './order.time.config';
import { eventsConfig } from './order.event.config';

import { imagesConfig } from './order.image.config';
import { alertConfig } from './order.alert.config';
import { completeRegistration } from './order.complete.registration';
import { ordersLoadConfig } from './order.load.config';
import { orderCSVConfig } from './order.csv.config';
import { orderTimelineConfig } from './order.timeline.config';
import { cancelConfig } from './order.cancel.config';
import { allocationConfig } from './order.allocation.config';
import { locationChangeConfig } from './order.location-change.config';
export type { TimelineNameId } from './order.timeline.config';
export type { CityChangeWindow } from './order.location-change.config';

export const order = {
  statusActivityConfig: statusActivityConfig,

  /** how to calculate time */
  timeConfig,

  /** the config for order actions such as `book_order` `arrived`  and what does these actions produce in terms of events & status updates for order & driver & destination status*/
  actionConfig,

  /** the events config is used for determining an event can be duplicated or not , and any other config for every event*/
  eventsConfig,

  /** the config of the order cancellation */
  cancelConfig,

  /** own-fleet auto-assignment policy (create hook + escalation cron) */
  allocationConfig,

  /**
   * Cross-city destination edit windows (`anytime` | `before_pickup`)
   * per stop type. Same-city pin moves ignore this.
   */
  locationChangeConfig,

  /** the temperature with degrees info */
  temperatureList,
  /** the list of available temperature types such as chilled/frozen/etc */
  temperatureTypesList,
  /** order images config such as the list of available image types */
  imagesConfig,
  /** this will be used by the admin panel only. */
  adminNextStepConfig,
  /** the config of the next step based on the order status */
  carrierNextStepConfig,
  /** alert config such as the color of alert level */
  alertConfig,
  /** the required info to complete the registration before starting to accept orders*/
  completeRegistration,
  /** the config of POD status. */
  podStatusConfig,

  ordersLoadConfig,
  /** the config of the order fields */
  orderFieldsConfig,
  /** the config of the order CSV */
  orderCSVConfig,
  orderTimelineConfig,
} as const;
